import toast from "react-hot-toast";
import  {client} from "@/app/ApolloClient";
import {gql} from "@apollo/client";

var mutation = gql`
  mutation createTemplate($organizationId: UUID!, $templateTypeId:  UUID!, $name: String!) {
    createTemplate(organizationId: $organizationId, templateTypeId: $templateTypeId, name: $name) {
      id
    }
  }  
`;



export function apiAddTemplate(organizationId, templateTypeId, name) {
    return new Promise(async (resolve, reject) => {
        if(!organizationId) reject("organizationId is required");

        client
            .mutate({
                mutation: mutation,
                variables: {organizationId, templateTypeId, name},
                fetchPolicy: "network-only"
            })
            .then((result) => {
                resolve(result.data.createTemplate);
            })
            .catch((err) => {
                toast.error("Api Error, Unable to create template");
                reject(err); // R
            })
    });
}
